import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
export function ToggleBoxBody({ children, className, }) {
    return (_jsx(Box, Object.assign({ padding: "0 300 300", className: className }, { children: children })));
}
